import { API_BASE_URL, getHeaders, handleResponse } from '../apiConfig';

export const fetchModules = async (courseId, params = {}) => {
  const query = new URLSearchParams();
  if (params && typeof params === 'object') {
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        query.append(key, params[key]);
      }
    });
  }
  const queryString = query.toString() ? `?${query.toString()}` : '';
  const response = await fetch(`${API_BASE_URL}/courses/${courseId}/modules${queryString}`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const createModule = async (courseId, moduleData) => {
  const response = await fetch(`${API_BASE_URL}/courses/${courseId}/modules`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(moduleData)
  });
  return handleResponse(response);
};

export const updateModule = async (id, moduleData) => {
  const response = await fetch(`${API_BASE_URL}/modules/${id}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(moduleData)
  });
  return handleResponse(response);
};

export const deleteModule = async (id) => {
  const response = await fetch(`${API_BASE_URL}/modules/${id}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const fetchModuleAccess = async (moduleId) => {
  const response = await fetch(`${API_BASE_URL}/modules/${moduleId}/access`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const grantModuleAccess = async (moduleId, payload) => {
  const response = await fetch(`${API_BASE_URL}/modules/${moduleId}/access`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(payload)
  });
  return handleResponse(response);
};

export const revokeModuleAccess = async (accessId) => {
  const response = await fetch(`${API_BASE_URL}/modules/access/${accessId}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const uploadModuleImage = async (formData) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${API_BASE_URL}/modules/upload-image`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`
    },
    body: formData
  });
  return handleResponse(response);
};
